/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Interchange_LabelInputs */

const en_fc_cmp_interchange_label = /** @type {(inputs: Fc_Cmp_Interchange_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project interchange`)
};

/**
* | output |
* | --- |
* | "Project interchange" |
*
* @param {Fc_Cmp_Interchange_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_interchange_label = /** @type {((inputs?: Fc_Cmp_Interchange_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Interchange_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_interchange_label(inputs)
});
export { fc_cmp_interchange_label as "fc.cmp.interchange.label" }